import {Injectable} from '@angular/core';
import {ApiConfig} from "../../models/api-config.model";

@Injectable({
  providedIn: 'root'
})
export class ApiConfigService {

  private appConfig: ApiConfig = {
    baseUrl: process.env.API_BASE_URL || (process.env.API_URL + '/v2'),
    debug: process.env.APP_DEBUG,
    env: process.env.APP_ENV,
    google: {
      mapsKey: process.env.GOOGLE_MAPS_KEY,
      clientId: process.env.GOOGLE_CLIENT_ID,
      analyticsTrackingId: process.env.GOOGLE_ANALYTICS_TRACKING_ID,
      tagId: process.env.GOOGLE_TAG_ID
    },
    heap: {
      appId: process.env.HEAP_APP_ID
    },
    microsoft: {
      clientId: process.env.MICROSOFT_CLIENT_ID,
      tenantId: process.env.MICROSOFT_TENANT_ID
    },
    firebaseUs: {
      apiKey: process.env.FIREBASE_US_API_KEY,
      databaseURL: process.env.FIREBASE_US_DB_URL,
      messagingSenderId: process.env.FIREBASE_US_SENDER_ID,
      webPushKey: process.env.FIREBASE_US_WEB_PUSH_KEY,
      projectId: process.env.FIREBASE_US_PROJECT_ID,
      appId: process.env.FIREBASE_US_APP_ID
    },
    firebaseEu: {
      apiKey: process.env.FIREBASE_EU_API_KEY,
      databaseURL: process.env.FIREBASE_EU_DB_URL,
      messagingSenderId: process.env.FIREBASE_EU_SENDER_ID,
      webPushKey: process.env.FIREBASE_EU_WEB_PUSH_KEY,
      projectId: process.env.FIREBASE_EU_PROJECT_ID,
      appId: process.env.FIREBASE_EU_APP_ID
    },
    intercom: {
      appId: process.env.INTERCOM_APP_ID,
    },
    zendesk: {
      apiKey: process.env.ZENDESK_API_KEY
    }
  };

  constructor() {
  }

  // async initializeApp(): Promise<AppConfig> {
  //   const res = await fetch('./assets/env-vars.json');
  //   return await res.json().then((settings: AppConfig) => {
  //     this.appConfig = settings;
  //     return settings;
  //   });
  // }

  get baseUrl() {
    return this.appConfig?.baseUrl;
  }

}
